// 引入vue 及 lodash
import Vue from 'vue'
import upperFirst from 'lodash/upperFirst' // 首字线大写
import camelCase from 'lodash/camelCase' // 驼峰命名大法
// 把 /component/global/ 下的所有 vue 组件 require 进来
// path: 要引入的组件所在相对路径（相对于当前文件）
// deep: 是否检索子文件夹
// matchFile: 匹配的文件名称
// require.context(path, deep, matchFile)
const requireComponent = require.context('../saasConfig/', true, /main-[\w-]+\.vue$/)
// 遍历 require 进来的组件并注册
requireComponent.keys().forEach((fileName) => {
  let view = fileName.split('/')[1]
  let compName = fileName.split('/')[fileName.split('/').length - 1]
  const componentConfig = requireComponent(fileName)

  let componentName = upperFirst(`${camelCase(compName.replace(/^\.\/_/, '').replace(/\.\w+$/, ''))}`)
  componentName = view + componentName
  // console.log('=====componentName========', componentName)
  // console.log('=====fileName========', fileName)

  // 全局注册组件
  Vue.component(componentName, componentConfig.default || componentConfig)
})
